import { render, staticRenderFns } from "./use-new-password.vue?vue&type=template&id=16407f20&scoped=true&"
import script from "./use-new-password.vue?vue&type=script&lang=tsx&"
export * from "./use-new-password.vue?vue&type=script&lang=tsx&"
import style0 from "./use-new-password.vue?vue&type=style&index=0&id=16407f20&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16407f20",
  null
  
)

export default component.exports